import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';

import s from 'components/userAvatar/userAvatar.sss';

// Based on https://github.com/bryc/code/blob/master/jshash/experimental/cyrb53.js
const getHash = (str, seed = 0) => {
	if (!str) return 0;
	let h1 = 0xdeadbeef ^ seed;
	let h2 = 0x41c6ce57 ^ seed;
	for (let char of str) {
		const code = char.charCodeAt(0);
		h1 = Math.imul(h1 ^ code, 0x85ebca77);
		h2 = Math.imul(h2 ^ code, 0xc2b2ae3d);
	}
	h1 ^= Math.imul(h1 ^ (h2 >>> 15), 0x735a2d97);
	h2 ^= Math.imul(h2 ^ (h1 >>> 15), 0xcaf649a9);
	h1 ^= h2 >>> 16;
	h2 ^= h1 >>> 16;
	return 2097152 * (h2 >>> 0) + (h1 >>> 11);
};

export default class UserAvatar extends Component {
	render({ user, size, ...props }) {
		if (!user) return <div {...props} class={joinClasses(props.class, s.avatar)} />;
		if (user.avatar) {
			// https://placehold.co/32x32
			return <img {...props} class={joinClasses(props.class, s.avatar)} src={user.avatar} alt="user icon" />;
		}
		const initial = user.name?.match(/[a-z]/i)?.[0] || user.email?.[0] || '';
		const hash = getHash(user.email);
		const background = (hash % 18) + 1;
		return (
			<div
				{...props}
				class={joinClasses(props.class, s.avatar, s.generated, s[`size-${size || 'medium'}`])}
				data-initial={initial}
				style={`background-image: url(${__IMAGE_ROOT__}/avatar-backgrounds/${background}.webp)`}
			/>
		);
	}
}